import { getLang } from "@/lib/i18n";

export const PAGES = {
  home: { tr: "/", en: "/en" },
  kesfet: { tr: "/kesfet", en: "/en/discover" },
  galeri: { tr: "/galeri", en: "/en/gallery" },
  ziyaret: { tr: "/ziyaret", en: "/en/visit" },
  iletisim: { tr: "/iletisim", en: "/en/contact" },
  gizlilik: { tr: "/gizlilik", en: "/en/privacy" },
  bilet: { tr: "/bilet", en: "/en/tickets" },
};

export const path = (key, lang = getLang()) => PAGES[key][lang];

export function pageOf(pathname) {
  const clean = pathname.replace(/\/+$/, "") || "/";
  return Object.keys(PAGES).find((k) => PAGES[k].tr === clean || PAGES[k].en === clean) || null;
}

export function toLang(pathname, lang, hash = "") {
  const key = pageOf(pathname);
  return key ? `${PAGES[key][lang]}${hash}` : PAGES.home[lang];
}
